import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { Outdent } from "lucide-react";

import Layout from "@/components/Layout";
import { AbilityProvider } from "@/hoc/AbilityProvider";
import { RoutePermissionGuard } from "@/hoc/RoutePermissionGuard";
import { authClient } from "@/utils/auth-client";
import { QUERY_KEYS } from "@/utils/constants";

export const Route = createFileRoute("/_authenticated")({
  loader: async ({ context }) => {
    const sessionData = await context.queryClient.ensureQueryData({
      queryKey: [QUERY_KEYS.SESSION],
      queryFn: async () => {
        const session = await authClient.getSession();
        return session;
      },
      staleTime: 5 * 60 * 1000, // 5 min: don't refetch until stale
    });

    if (!(sessionData?.data?.session && sessionData?.data?.user)) {
      throw redirect({ to: "/login" });
    }
    // return { permissions: permissions.data };
  },

  component: () => {
    return (
      <AbilityProvider>
        <RoutePermissionGuard>
          <Layout>
            <Outlet />
          </Layout>
        </RoutePermissionGuard>
      </AbilityProvider>
    );
  },
  notFoundComponent: () => (
    <div>
      <h1>Not Found!</h1>
      <p>The page you are looking for does not exist.</p>
      <Outdent />
    </div>
  ),
});
